<template>
  <v-row class="add-client-form no-padding">
    <successModal
      ref="success_modal"
      v-on:confirm="closeSuccessModal"
    ></successModal>
    
  <errorModal 
    ref="error_modal"
     v-on:confirm="closeErrorModal">
    </errorModal>


    <div class="col-md-12">
      <div class="row  blue-underline mt-2 margin-l-11">
        <div class="col-md-12">
          <h3 class="form-title font ml-2 mb-2 font-18" >New Client</h3>
        </div>
      </div>
      <v-form v-model.trim="valid" ref="form" class="row">
        <div class="col-md-6">
          <div class="col-md-12">
            <label class="font " for="">Company Name</label>
            <v-text-field
              required
              :rules="requiredRules"
              v-model.trim="member.companyName"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12">
            <label class="font text-gray " for=""
              >Company Display Name</label
            >
            <v-text-field
              required
              :rules="requiredRules"
              v-model.trim="member.displayName"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12">
            <label class="font text-gray" for="">Tax ID</label>
            <v-text-field
              required
              v-model.trim="member.taxId"
              @keyup="showSlash($event)"
              solo
              placeholder="00-0000000"
              :rules="taxIdRules"
              counter="10"
              maxlength="10"
            ></v-text-field>
          </div>
          <div class="col-md-12">
            <label class="font text-gray" for="">Number of Employees</label>
            <v-text-field required v-model.trim="member.employeesNo" solo></v-text-field>
          </div>
          <div class="col-md-12">
            <label class="font text-gray" for="">Number of Plan Members</label>
            <v-text-field required v-model.trim="member.membersNo" solo></v-text-field>
          </div>
          <div class="col-md-12">
            <label class="font text-gray" for="">HQ Address Line 1</label>
            <v-text-field
              required
              v-model.trim="member.address1"
              :rules="requiredRules"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12">
            <label class="font text-gray" for="">HQ Address Line 2</label>
            <v-text-field required v-model.trim="member.address2" solo></v-text-field>
          </div>
          <v-row class="no-padding">
            <div class="col-md-6">
              <label class="font text-gray" for="">City</label>
              <v-text-field
                required
                v-model.trim="member.city"
                solo
                :rules="requiredRules"
              ></v-text-field>
            </div>
            <div class="col-md-3">
              <label class="font text-gray" for="">State</label>
              <v-select
                :items="states"
                item-text="name"
                item-value="name"
                required
                v-model.trim="member.state"
                solo
                :rules="requiredRules"
              ></v-select>
            </div>
            <div class="col-md-3">
              <label class="font text-gray" for="">Zip</label>
              <v-text-field
                required
                type="number"
                v-model.trim="member.zip"
                solo
                :rules="zipRules"
              ></v-text-field>
            </div>
          </v-row>
        </div>
        <div class="col-md-6">
          <div class="col-md-12">
            <label class="font text-gray" for=""
              >Primary Contact First Name
            </label>
            <v-text-field
              required
              v-model.trim="member.firstName"
              solo
              :rules="requiredRules"
            ></v-text-field>
          </div>
          <div class="col-md-12">
            <label class="font text-gray" for=""
              >Primary Contact Last Name</label
            >
            <v-text-field
              required
              v-model.trim="member.lastName"
              solo
              :rules="requiredRules"
            ></v-text-field>
          </div>
          <div class="col-md-12">
            <label class="font text-gray" for="">Primary Contact Title</label>
            <v-text-field
              required
              v-model.trim="member.title"
              solo
              :rules="requiredRules"
            ></v-text-field>
          </div>
          <div class="col-md-12">
            <label class="font text-gray" for="">Primary Contact Email</label>
            <v-text-field
              required
              :rules="emailRules"
              v-model.trim="member.email"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12">
            <label class="font text-gray" for="">Primary Contact Phone</label>
            <v-text-field
              required
              v-model.trim="member.phone"
              solo
              :rules="phoneRules"
            ></v-text-field>
          </div>
        </div>
        <div class="col-md-12 row text-end justify-end mb-5">
          <span   class="text-underline pointer mr-10" 
          style="color:#0572F3;"
          @click="$router.go(-1)">
          Cancel</span>
           <span  class="text-underline pointer mr-2"
           style="color:#0572F3;"
           @click="update">
           Save & Invite</span>
        </div>
      </v-form>
    </div>
  </v-row>
</template>
<script>
import api from "../../../../../services/api";
import successModal from "../../../../TablesTemplate/SuccessDialog.vue";
import errorModal from "../../../../TablesTemplate/ErrorDialog.vue";

export default {
  components: { successModal, errorModal },
  data() {
    return {
      member: {
        companyName: "",
        taxId: "",
        logo: "",
        phone: "",
        title: "",
        firstName: "",
        lastName: "",
        email: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        displayName: "",
        membersNo: "",
        employeesNo: "",
      },

        phoneRules:[
      (v) => /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(v) || "Phone number must be in a valid format (XXX XXX XXXX)",
      ],
      states: [],
      discountRate: "",
      valid: false,
      zipRules: [
        (v) => (v && v.length == 5) || " Zip Code should be five digits long",
      ],
      requiredRules: [(v) => !!v || "This field is required"],
      emailRules: [
        (v) => !!v || "This field is required",
        (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "E-mail must be valid",
      ],
      taxIdRules: [
        (v) => !!v || "This field is required",
        (v) =>
          !!/[0-9]{2}\-[0-9]{7}/.test(v) ||
          "Tax ID should contain 9 digits, Please enter your Tax ID in XX-XXXXXXX format",
      ],
    };
  },
  computed: {
    singleMember() {
      return this.$store.getters.getSingleMember;
    },
    
  },
  created() {
    // this.getStates();
    // this.getInfo();
    // this.member = this.singleMember
  },
  methods: {
    closeErrorModal() {
      this.$refs.error_modal.closePopUp();
    },
    generatePdf() {
      window.open("https://api.apaly.net/terms");
    },
    showSlash(event) {
      if (this.taxId.length == 2 && event.keyCode != 8) {
        this.taxId += "-";
      }
    },
    activateFileInput() {
      this.$refs.fileInput.$refs.input.click();
    },
    getStates() {
      api()
        .get("/api/states")
        .then((res) => {
          res.data.forEach((el) => {
            if (el.active) {
              this.states.push(el);
            }
          });
        });
    },
    getInfo() {
      let user = JSON.parse(localStorage.getItem("user"));
      let provider = user.entity._id;

      api()
        .get(`/providers/${provider}`)
        .then((res) => {
          if (res) {
            this.companyName = res.data.provider.providerName
              ? res.data.provider.providerName
              : res.data.provider.companyName
              ? res.data.provider.companyName
              : "";
            this.displayName = res.data.provider.displayName
              ? res.data.provider.displayName
              : "";
            this.taxId = res.data.provider.taxId ? res.data.provider.taxId : "";
            this.address1 = res.data.provider.address1
              ? res.data.provider.address1
              : "";
            this.address2 = res.data.provider.address2
              ? res.data.provider.address2
              : "";
            this.website = res.data.provider.website
              ? res.data.provider.website
              : "";
            this.city = res.data.provider.city ? res.data.provider.city : "";
            this.state = res.data.provider.state ? res.data.provider.state : "";
            this.zip = res.data.provider.zipCode
              ? res.data.provider.zipCode
              : "";
            this.firstName = res.data.provider.primaryContact.firstName
              ? res.data.provider.primaryContact.firstName
              : "";
            this.lastName = res.data.provider.primaryContact.lastName
              ? res.data.provider.primaryContact.lastName
              : "";
            this.title = res.data.provider.primaryContact.title
              ? res.data.provider.primaryContact.title
              : "";
            this.phone = res.data.provider.primaryContact.phone
              ? res.data.provider.primaryContact.phone
              : "";
            this.email = res.data.provider.primaryContact.email
              ? res.data.provider.primaryContact.email
              : "";
            this.dataComponents.image.name = res.data.provider.logo
              ? res.data.provider.logo
              : "";
            this.dataComponents.profileImage.name = res.data.provider
              .primaryContact.profile
              ? res.data.provider.primaryContact.profile
              : "";
          }
        });
    },
    closeSuccessModal() {
      this.$refs.success_modal.closePopUp();
      this.$router.push("/dpc-providers/clients");
    },

    update() {
      this.$refs.form.validate();
      if (false) {
        let data = {
          companyName: this.companyName,
          providerName: this.companyName,
          displayName: this.displayName,
          address1: this.address1,
          address2: this.address2,
          website: this.website,
          city: this.city,
          state: this.state,
          zipCode: this.zip,
          taxId: this.taxId,
          firstName: this.firstName,
          lastName: this.lastName,
          title: this.title,
          phone: this.phone,
          email: this.email,
        };

        let user = JSON.parse(localStorage.getItem("user"));
        let provider = user.entity._id;
        let formData = new FormData();
        formData.append("_method", "PUT");
        formData.append("image", this.imageEvent);

        api()
          .put(`/providers/${provider}`, data)
          .catch((err) => {
                  if (err.response.status == 500) {
                    this.$refs.error_modal.openPopUp(
                      "There was an error, system admin is notified. Please try again later."
                    );}
                   else{
                    this.$refs.error_modal.openPopUp(err.response.data)
                   }
                  
                })
          .then((res) => {
            if (res) {
              if (this.profileChange) {
                if (this.imageProfleEvent) {
                  let formData = new FormData();
                  formData.append("_method", "PUT");
                  formData.append("image", this.imageProfleEvent);
                  api()
                    .put(`/providers/${provider}/profile`, formData)
                    .then((res) => {
                      document.getElementById("profile-img").click();
                    });
                } else {
                  api()
                    .delete(`/providers/${provider}/profile`)
                    .then((res) => {
                      document.getElementById("profile-img").click();
                    });
                }
              }
              if (this.logoChange) {
                if (this.imageEvent) {
                  let formData = new FormData();
                  formData.append("_method", "PUT");
                  formData.append("image", this.imageEvent);
                  api()
                    .put(`/providers/${provider}/logo`, formData)
                    .catch((err) => {
                  if (err.response.status == 500) {
                    this.$refs.error_modal.openPopUp(
                      "There was an error, system admin is notified. Please try again later."
                    );}
                   else{
                    this.$refs.error_modal.openPopUp(err.response.data)
                   }
                  
                })
                    .then((res) => {
                      document.getElementById("logo-img").click();
                    });
                } else {
                  api()
                    .delete(`/providers/${provider}/logo`)
                    .catch((err) => {
                  if (err.response.status == 500) {
                    this.$refs.error_modal.openPopUp(
                      "There was an error, system admin is notified. Please try again later."
                    );}
                   else{
                    this.$refs.error_modal.openPopUp(err.response.data)
                   }
                  
                })
                    .then((res) => {
                      document.getElementById("logo-img").click();
                    });
                }
              }

              this.$refs.success_modal.openPopUp(
                "Account updated successfully"
              );
              this.logoChange = false;
              this.profileChange = false;
            }
          });
      }

      this.$refs.success_modal.openPopUp("Client added successfully");
    },
  },
};
</script>